import NationalMemberOrganizations from '@/services/Api/NationalMemberOrganizations';
import AssociateMemberOrganizations from '@/services/Api/AssociateMemberOrganizations';

export default {
  data() {
    return {
      isLoading: false,
    };
  },

  mounted() {
    this.fetchMemberOrganizations();
  },

  methods: {
    onRowClicked({ data }) {
      const countryCode = data?.country?.code;

      if (!countryCode) {
        return;
      }

      this.$router.push({
        path: `/affiliates/officials/${this.category.id}/${countryCode}`,
      });
    },

    async fetchMemberOrganizations() {
      this.isLoading = true;
      try {
        const response = this.category.id === 'amo'
          ? await AssociateMemberOrganizations.all()
          : await NationalMemberOrganizations.all();

        if (response.data.status === 200) {
          this.setAffiliates(response.data.data ?? []);
        }
      } catch (error) {
        console.error(error);
        this.rowData = [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
